export default "__VITE_ASSET__9794cf27__"